import type * as React from 'react'
import { useState } from 'react'
import { NavLink } from 'react-router-dom-v5-compat'

import { useSplitEnabled } from '@buffer-mono/features'
import {
  TagIcon,
  SettingsIcon,
  Tooltip,
  Sidebar,
  Skeleton,
} from '@buffer-mono/popcorn'

import { TagManagementDialog } from '~publish/components/TagManagementDialog'
import {
  useCurrentOrganization,
  useIsAdmin,
} from '~publish/contexts/AccountContext'
import {
  settingsChannelsRoute,
  settingsTagsRoute,
  tagsPage,
} from '~publish/legacy/routes'

import styles from './ManagementNav.module.css'

export const ManagementNav: React.FC = () => {
  const organization = useCurrentOrganization()
  const isAdmin = useIsAdmin()
  const ownerEmail = organization?.ownerEmail
  const { isEnabled: newTagManagerEnabled } = useSplitEnabled(
    'enable_dialog_tag_manager',
  )
  const { isEnabled: newTagsPageEnabled } = useSplitEnabled(
    'tags-management-on-settings',
  )
  const [tagManagerOpen, setTagManagerOpen] = useState(false)

  return (
    <>
      <TagManagementDialog
        open={tagManagerOpen}
        onOpenChange={setTagManagerOpen}
      />
      <Sidebar.List>
        <Sidebar.ListItem>
          <Skeleton show={!organization}>
            {newTagsPageEnabled && (
              <Sidebar.Button
                as={NavLink}
                to={settingsTagsRoute.route}
                prefix={<TagIcon />}
                className={styles.button}
              >
                {isAdmin ? 'Manage Tags' : 'View Tags'}
              </Sidebar.Button>
            )}
            {!newTagsPageEnabled && newTagManagerEnabled && (
              <Sidebar.Button
                onClick={(): void => setTagManagerOpen(true)}
                prefix={<TagIcon />}
                className={styles.button}
              >
                {isAdmin ? 'Manage Tags' : 'View Tags'}
              </Sidebar.Button>
            )}
            {!newTagsPageEnabled && !newTagManagerEnabled && (
              <Sidebar.Button
                as={NavLink}
                to={tagsPage.route}
                prefix={<TagIcon />}
                className={styles.button}
              >
                {isAdmin ? 'Manage Tags' : 'View Tags'}
              </Sidebar.Button>
            )}
          </Skeleton>
        </Sidebar.ListItem>
        <Sidebar.ListItem>
          <Skeleton show={!organization}>
            {isAdmin ? (
              <Sidebar.Button
                as={NavLink}
                to={settingsChannelsRoute.route}
                prefix={<SettingsIcon />}
                data-testid="profile-sidebar-channels-action"
                className={styles.button}
              >
                Manage Channels
              </Sidebar.Button>
            ) : (
              <Tooltip
                content={`It looks like you haven't been given permission to add/manage channels. Request access from ${
                  ownerEmail ?? 'the owner'
                } or any other administrator.`}
              >
                <Sidebar.Button
                  disabled
                  prefix={<SettingsIcon />}
                  data-testid="profile-sidebar-channels-action"
                  className={styles.button}
                >
                  Manage Channels
                </Sidebar.Button>
              </Tooltip>
            )}
          </Skeleton>
        </Sidebar.ListItem>
        {/* {featureOsWidget && (
          <Sidebar.ListItem>
            <Sidebar.Button
              className={styles.button}
              prefix={<QuestionIcon />}
              onSelect={featureOsWidget.open}
            >
              What&apos;s New
              <AlphaBadge size="small" style={{ marginLeft: '4px' }} />
            </Sidebar.Button>
          </Sidebar.ListItem>
        )} */}
      </Sidebar.List>
    </>
  )
}
